import type { LinkHeroDto } from '@hcr/api/optimizely'
import type { Link } from '@hcr/ui'

import { Path } from '../../../../models'
import { to } from '../../../navigation'

export const createLinkHero = (dto: LinkHeroDto): Link => ({
  isExternal: false,
  label: dto.label,
  to: to(Path.Home),
})
